import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import VacationItem from "../components/vacation-item";
import Toggle from "../components/switch";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

export default function DaysHalf({
  onSelectedDateFrom,
  onSelectedDateTo,
  dateTo,
  dateFrom,
  checked,
  onChecked,
  defaultAM,
  onHandleToggle,
  canSelectPast,
  isMobile,
}) {
  return (
    <>
      <div className="check-in-out-container" id="days-half-from-container">
        <CalendarPicker
          label={"From"}
          isStanAlone
          onSelected={(value, str) => onSelectedDateFrom(value, str)}
          value={dateFrom}
          isDisablePast={!canSelectPast}
          id="days-half-calendar-from-component"
        />
        {checked && (
          <Toggle
            defaultAM={defaultAM}
            onHandleToggle={() => onHandleToggle()}
            id="days-half-toggle-half-day-component"
          />
        )}
      </div>
      <div className="check-in-out-container" id="days-half-to-container">
        <CalendarPicker
          label={"To"}
          isStanAlone
          onSelected={(value, str) => onSelectedDateTo(value, str)}
          value={dateTo}
          isDisablePast={!canSelectPast}
          id="days-half-calendar-to-component"
        />
        {checked && (
          <div
            className="empty"
            id="empty-view"
            style={{
              marginLeft: 20,
              marginRight: 20,
              width: isMobile ? 205 : 155,
            }}
          ></div>
        )}
      </div>
      <div className="toggle" id="days-half-half-day-container">
        <VacationItem
          checked={checked}
          onChecked={onChecked}
          title={"Half day"}
          icon={HourglassBottomIcon}
          color={"orange"}
          id="days-half-half-day-component"
        />
      </div>
    </>
  );
}
